const TermsStep = () => (
  <div className='flex flex-col items-start justify-center h-full gap-8 px-10 mb-40'>
    <div className='space-y-4'>
      <span className='text-main font-bold text-[18px]'>Credit Builder terms & conditions</span>
    </div>

    <div className='flex flex-col items-start gap-6 text-base'>
      <div className='flex flex-col items-start gap-2'>
        <span className='text-main font-bold'>Lease verification</span>
        <span className='text-main'>
          TenantPay needs to verify your lease agreement before we can start reporting your rent. If
          there are any issues, we will let you know what needs to be updated.
        </span>
      </div>

      <div className='flex flex-col items-start gap-2'>
        <span className='text-main font-bold'>Information we share</span>
        <span className='text-main'>
          We share your full name, date of birth, phone number, full address, and details about your
          rent payments. Your data is secure with us. We share your information ONLY with Equifax for
          rent reporting purposes. You can learn more by visiting Equifax&apos;s Privacy Policy.
        </span>
      </div>

      <div className='flex flex-col items-start gap-2'>
        <span className='text-main'>
          Your data is secure with us. We share your information ONLY with Equifax for rent reporting
          purposes. You can learn more by visiting Equifax&apos;s Privacy Policy.
        </span>
      </div>
    </div>
  </div>
);

export default TermsStep;
